import React, { useCallback } from 'react';
import { View } from '../../../store/types';
import { flipView } from '../../../store/reducer';
import config from '../../../config/index';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { ErrorLink } from '../../shared.styles';
import { Container } from './ForcePasswordReset.styles';
import { getTexts } from '../../../lib/contentful/defaultTexts';
var ForcePasswordReset = function ForcePasswordReset() {
  var dispatch = useAppDispatch();
  var env = useAppSelector(function (state) {
    return state.env;
  });
  var _getTexts = getTexts(),
    _getTexts$login = _getTexts.login,
    passwordForceResetError = _getTexts$login.passwordForceResetError,
    passwordForceResetLinkError = _getTexts$login.passwordForceResetLinkError,
    passwordForceResetTwoError = _getTexts$login.passwordForceResetTwoError,
    passwordForceResetLearnMoreLinkError = _getTexts$login.passwordForceResetLearnMoreLinkError;
  var flipToResetPassword = useCallback(function (e) {
    e.preventDefault();
    dispatch(flipView({
      view: View.RESET_PASSWORD
    }));
  }, [dispatch]);
  return /*#__PURE__*/React.createElement(Container, {
    "data-test": "force_password_reset"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, passwordForceResetError), /*#__PURE__*/React.createElement(ErrorLink, {
    href: "/",
    "data-test": "force_password_reset_flip_to_forgot_password",
    onClick: flipToResetPassword
  }, passwordForceResetLinkError), /*#__PURE__*/React.createElement("span", null, passwordForceResetTwoError), /*#__PURE__*/React.createElement(ErrorLink, {
    href: config[env].forcePasswordResetFAQUrl,
    target: "_blank"
  }, passwordForceResetLearnMoreLinkError)));
};
export default ForcePasswordReset;